import moment from 'moment';

type CoolingOffInput = {
  coolingOffPeriodEndDt?: string | null;
  plans?: Array<{
    freeTrialEndDt?: string | null;
  }>;
};

const calculateCoolingOffEligibility = ({ coolingOffPeriodEndDt, plans }: CoolingOffInput): boolean => {
  const freeTrialEndDt = plans?.[0]?.freeTrialEndDt;

  if (!coolingOffPeriodEndDt || (freeTrialEndDt && moment(freeTrialEndDt).isAfter(moment()))) {
    return false;
  }

  return moment(coolingOffPeriodEndDt).isAfter(moment());
};

export default calculateCoolingOffEligibility;
